import { BEHAVIOUR_DRAG_DELETE } from "../../../constants";
export const handleBehaviourDragDelete = (payload, cb) => {
    return {
         type: BEHAVIOUR_DRAG_DELETE,
         payload
    }
}